import { createSlice } from "@reduxjs/toolkit";

const load = () => {
    try {
        return JSON.parse(localStorage.getItem("auth")) || null;
    } catch {
        return null;
    }
};

// passwordExpired: the sign-in response said the password must be reset.
// The session exists (so the reset API can be called) but the app must not
// let the user past /reset-password until it is done.
const empty = { token: null, user: null, storageLocation: null, passwordExpired: false };

const authSlice = createSlice({
    name: "auth",
    initialState: { ...empty, ...(load() || {}) },
    reducers: {
        setCredentials: (state, { payload }) => {
            state.token = payload.token;
            state.user = payload.user;
            state.storageLocation = payload.storageLocation;
            state.passwordExpired = !!payload.passwordExpired;
        },
        logout: () => empty,
    },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;

export const selectToken = (s) => s.auth.token;
export const selectUser = (s) => s.auth.user;
export const selectStorageLocation = (s) => s.auth.storageLocation;
export const selectPasswordExpired = (s) => s.auth.passwordExpired;